import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import workflowRunFetched, {
	type WorkflowRunFetchedAction,
	type WorkflowRunPayload,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';
import workflowRunFetchFailed, {
	type WorkflowRunFetchFailedAction,
} from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetchFailed';
import type FetchWorkflowRun from '@Application/WorkflowRuns/WorkflowRun/Queries/FetchWorkflowRun';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = WorkflowRunFetchedAction | WorkflowRunFetchFailedAction;

export default (query: FetchWorkflowRun) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<WorkflowRunPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/workflow-runs/${query.runId}`,
			);

			const action = workflowRunFetched(
				payload,
				query.facilityId,
				query.subject.typeKey,
				query.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = workflowRunFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
